/**
 * §48 — a barra mede conteúdo concluído.
 *
 * Leva sempre o número por escrito ao lado: uma barra sozinha é uma sensação,
 * e o rótulo diz de quantas lições em quantas se está a falar. `aria-valuenow`
 * existe pela mesma razão, para quem não vê a barra.
 */
export function ProgressBar({ value, label }: { readonly value: number; readonly label: string }) {
  return (
    <div className="et-progress">
      <div
        className="et-progress__track"
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label}
      >
        <span className="et-progress__fill" style={{ width: `${Math.max(0, Math.min(100, value))}%` }} />
      </div>
      <span className="et-progress__label">{value}% · {label}</span>
    </div>
  );
}
